import { useState, useEffect } from 'react';
import { RiCookieLine } from '@remixicon/react';
import { useLang } from '../../i18n/translations';

const STORAGE_KEY = 'idanroh-cookie-consent';
type Choice = 'all' | 'essential';

export function CookieBanner() {
  const { t } = useLang();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) {
      const timer = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  function choose(c: Choice) {
    localStorage.setItem(STORAGE_KEY, c);
    setVisible(false);
    if (c === 'all') {
      window.dispatchEvent(new CustomEvent('cookie-consent-accepted'));
    }
  }

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-line-light shadow-[0_-4px_24px_rgba(0,0,0,0.08)]"
      role="dialog"
      aria-label="Consentement aux cookies"
    >
      <div className="max-w-[480px] mx-auto px-5 py-4 flex items-start gap-3">
        <div className="w-9 h-9 rounded-xl bg-brand-light flex items-center justify-center shrink-0">
          <RiCookieLine className="h-4 w-4 text-brand" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-[13px] font-display text-ink-secondary leading-snug">
            {t.cookie.text}
          </p>
          <p className="text-[11px] text-ink-faint mt-1 font-display">
            <a href="/confidentialite/" className="underline hover:text-brand">{t.cookie.privacy}</a>
            <span className="mx-1.5">·</span>
            <a href="/conditions/" className="underline hover:text-brand">{t.cookie.terms}</a>
          </p>
        </div>
        <div className="flex flex-col gap-1.5 shrink-0">
          <button
            onClick={() => choose('all')}
            className="h-9 px-4 rounded-xl text-[13px] font-display font-semibold bg-brand text-white"
          >
            {t.cookie.accept}
          </button>
          <button
            onClick={() => choose('essential')}
            className="h-9 px-3 rounded-xl text-[13px] font-display text-ink-muted border border-line-light"
          >
            {t.cookie.refuse}
          </button>
        </div>
      </div>
    </div>
  );
}
